/* JAYKEI FAQ accordion. The panel animates through grid-template-rows 0fr -> 1fr,
   so the open height comes from the content itself - no measuring, and it stays
   correct when the answer reflows. */
(function () {
  'use strict';
  function init() {
    [].forEach.call(document.querySelectorAll('[data-jk-faq]'), function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('.jk-faq__q');
        if (!btn || !root.contains(btn)) return;
        var item = btn.closest('[data-jk-faq-item]');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
